import "vite/modulepreload-polyfill";
import "@/assets/styles/main.sass";

import * as Sentry from "@sentry/vue";

import { createApp, DefineComponent, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import VueScrollTo from "vue-scrollto";
import axios from "axios";

import routeReverse from "@/plugins/route-reverse";
import translations from "@/plugins/translations";

const pages = import.meta.glob("./pages/**/*.vue");

axios.defaults.xsrfCookieName = "www_csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

createInertiaApp({
    resolve: async (name) => {
        return (await pages[`./pages/${name}.vue`]()) as DefineComponent;
    },
    setup({ el, App, props, plugin }) {
        const vueApp = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(routeReverse)
            .use(translations);

        if (props.initialPage.props.envSentryDsn) {
            Sentry.init({
                app: vueApp,
                dsn: props.initialPage.props.envSentryDsn as string,
                integrations: [Sentry.browserTracingIntegration()],
                environment: props.initialPage.props.envEnvironment as string,
                release: props.initialPage.props.envReleaseReference as string,
            });
        }
        vueApp.directive("scroll-to", VueScrollTo);
        vueApp.mount(el);
    },
    progress: {
        color: "#fa4858",
    },
});
